import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AlarmProbableCausePipe} from './alarm-probable-cause-pipe';
import {AlarmSeverityPipe} from './alarm-severity-pipe';
import {AlarmTypePipe} from './alarm-type-pipe';
import { AlarmSeverityTablePipe } from './alarm-severity-table.pipe';



@NgModule({
  declarations: [
    AlarmProbableCausePipe,
    AlarmSeverityPipe,
    AlarmTypePipe,
    AlarmSeverityTablePipe
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    AlarmProbableCausePipe,
    AlarmSeverityPipe,
    AlarmTypePipe
  ]})
export class AlarmPipesModule { }
